<div class="selected-products-list">
  @for (slot of displaySlots; track $index) {
    <div class="slot-item">
      @if (isProduct(slot)) {
        <lib-bundle-product-list-item-selected
          [product]="slot"
          [selectedProducts]="selectedProducts"
          (remove)="onRemove(slot)"
        />
      } @else if (isPlaceholder(slot)) {
        <div class="container-placeholder">
          <div class="placeholder-container">
            <div class="placeholder-item">
              <div class="placeholder-content">
                <p class="gray">
                  Add {{ $index + 1 }}{{ getSuffix($index + 1) }} item
                </p>
                @if (slot.discountPercentage) {
                  <span class="title-no-item">
                    @if (slot.showFreeShipping) {
                      Free Shipping +
                    }
                    {{ slot.discountPercentage }}% Off
                  </span>
                }
              </div>
            </div>
          </div>
          <h3 class="title-item">{{ slot.placeholderText }}</h3>
        </div>
      }
    </div>
  }
</div>
